import { render } from "./UpdateShopProduct.vue?vue&type=template&id=8b59b0e6"
import script from "./UpdateShopProduct.vue?vue&type=script&lang=js"
export * from "./UpdateShopProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__